import { FC } from "react";
import { IconButton } from "@chakra-ui/react";

type CloseBtnProps = {
  onClose: () => void;
};
const CloseBtn: FC<CloseBtnProps> = ({ onClose }) => {
  return (
    <IconButton
      justifyContent={"center"}
      alignItems={"center"}
      w={{ base: "32px", md: "48px"}}
      maxW={{ base: "32px", md: "48px"}}
      h={{ base: "32px", md: "48px"}}
      p={{ base: "0.65rem", md: "1rem" }}
      bgColor={"#F9F9F9"}
      borderRadius={"50%"}
      onClick={onClose}
      cursor={"pointer"}
      aria-label="Close"
      icon={
        <svg
          width="16"
          height="15"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="15.1036"
            y1="0.603553"
            x2="1.60355"
            y2="14.1036"
            stroke="black"
          />
          <line
            y1="-0.5"
            x2="19.0919"
            y2="-0.5"
            transform="matrix(0.707107 0.707107 0.707107 -0.707107 1.25 0.25)"
            stroke="black"
          />
        </svg>
      }
    />
  );
};

export default CloseBtn;
